import { useRouter } from 'next/router'
import React, { useState, useEffect } from 'react'
import { useAppContext } from '../../context/siteMapContext'
import { WebMenuTypeEnum } from '../../interfaces/webMenu'
import SearchField from '../searchField.component'
import CompactBlockContent from './compactBlockContent.component'
import HeaderBackgroundLayout from './headerBackgroundLayout.component'
import Logo from './logo.component'

const SubPageHeader = ({
  searchPlaceholder = 'Keresőszó vagy kifejezés...',
  sloganTop_HU = 'Távol a belvárostól, közel egymáshoz.',
  activePage,
  headerImage
}: any) => {
  const { highContrastOn } = useAppContext();
  const [subPageHeaderData, setHeaderData] = useState<any>({})
  const router = useRouter();

  const navigateToSearchPage = (input: string) => {
    router.replace('search', `kereses?kifejezes=${input}`)
  }

  useEffect(() => {
    if (activePage) {
      const { iconUrl, iconColor, backgroundColor, name_HU, name_EN } =
        activePage
      setHeaderData({
        iconUrl: iconUrl,
        iconColor: iconColor,
        backgroundColor: backgroundColor,
        name_HU: name_HU,
        name_EN: name_EN,
        isHomePage: false,
      })
    }
  }, [activePage])

  return (
    <header className='relative flex flex-col bg-top h-subpage-header 2xl:flex-row 2xl:gap-desktop 2xl:h-subpage-header-2xl 2xl:justify-between text-white text-header-text font-semibold font-montserrat 2xl:text-header-text-2xl'>
      <Logo />
      <div className='z-0 absolute w-full h-subpage-header 2xl:h-subpage-header-2xl bg-black'>
        {!highContrastOn && <HeaderBackgroundLayout headerImage={headerImage}>
          <div
            style={{ backgroundColor: subPageHeaderData?.backgroundColor }}
            className='absolute inset-y-0 right-0 z-0 opacity-95 header-block-bg 2xl:header-block-bg-desktop w-3/4 2xl:w-1/3'
          />
        </HeaderBackgroundLayout>}
      </div>
      <div className='z-1 flex justify-end w-full py-6 px-mobile 2xl:w-1/3 order-2 2xl:order-1'>
        <div className='flex w-full 2xl:w-3/4 h-full items-center'>
          {activePage?.type !== WebMenuTypeEnum.SEARCH && <SearchField searchPlaceholder={searchPlaceholder} value='' search={navigateToSearchPage} />}
        </div>
      </div>
      <div className='z-1 w-full 2xl:w-1/3 order-1 2xl:order-2'>
        <CompactBlockContent
          slogan={sloganTop_HU}
          headerData={subPageHeaderData}
        />
      </div>
    </header>
  )
}

export default SubPageHeader
